export const THREAD_USER_READ = 'THREAD_USER_READ'

export const FETCH_THREAD_COUNTERS_REQUEST = 'FETCH_THREAD_COUNTERS_REQUEST'
export const FETCH_THREAD_COUNTERS_RESPONSE = 'FETCH_THREAD_COUNTERS_RESPONSE'
export const FETCH_THREAD_COUNTERS_ERROR = 'FETCH_THREAD_COUNTERS_ERROR'

export const THREADS_INSTAGRAM_STORY_FETCH = 'THREADS_INSTAGRAM_STORY_FETCH'

export const LIVE_CHAT_SHOW_ALL_CHANNELS_HISTORY_MODAL = 'LIVE_CHAT_SHOW_ALL_CHANNELS_HISTORY_MODAL'
export const LIVE_CHAT_CLOSE_ALL_CHANNELS_HISTORY_MODAL =
  'LIVE_CHAT_CLOSE_ALL_CHANNELS_HISTORY_MODAL'

export const LIVE_CHAT_SEARCH_RESULTS_CLICK = 'LIVE_CHAT_SEARCH_RESULTS_CLICK'
export const LIVE_CHAT_RESET_ACTIVE_MESSAGE = 'LIVE_CHAT_RESET_ACTIVE_MESSAGE'

export const UPDATE_USER_COUNTERS = 'UPDATE_USER_COUNTERS'
export const UPDATE_UNREAD_THREADS = 'UPDATE_UNREAD_THREADS'

export const SCHEDULED_MESSAGES_GET_LIST_SUCCESS = 'SCHEDULED_MESSAGES_GET_LIST_SUCCESS'
export const SCHEDULED_MESSAGES_CREATE_SUCCESS = 'SCHEDULED_MESSAGES_CREATE_SUCCESS'
export const SCHEDULED_MESSAGES_UPDATE_SUCCESS = 'SCHEDULED_MESSAGES_UPDATE_SUCCESS'
export const SCHEDULED_MESSAGES_DELETE_SUCCESS = 'SCHEDULED_MESSAGES_DELETE_SUCCESS'
export const SCHEDULED_MESSAGES_LIST_CLEAR = 'SCHEDULED_MESSAGES_LIST_CLEAR'
